const fontFamily = '"Open Sans", "Segoe UI", Tahoma, sans-serif';
export {
  fontFamily
};
//# sourceMappingURL=index219.js.map
